import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge, Button, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ResourceManager } from '../../../core/resource-manager';
import { LoginManager } from '../../../core/login-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';




export default function CardCapitolo({ data, courseGranted = true }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);
    const [blocked, setBlocked] = useState(false);
    const userInfo = LoginManager.getUserInfo();


    const [episodesStats, setEpisodesStats] = useState(null);
    async function getUserStats() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idEpisode",
                "type": "value",
                "value": data.id
            }
        ]
        var response = await DataManager.searchItems('episode_user', 1, 1, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            console.warn('STATS', response.body[0])
            setEpisodesStats(response.body[0])
        }
    }


    async function getUserAccess() {
        let constraintsEpisode = [
            {
                "fieldName": "idUser",
                "type": "value",
                "value": userInfo.id
            },
            {
                "fieldName": "idEpisode",
                "type": "value",
                "value": data.id
            }
        ];
        var sortingEpisode = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('episode_user_active', 1, 1, sortingEpisode, '', [], constraintsEpisode)
        if (response.success === 1) {
            if(response.body.length > 0) {
                setBlocked(false)
            }
            else {
                setBlocked(true)
            }
        }
    }

    useEffect(() => {
        setImage(data.image ? ResourceManager.getFileUrl(data.image, 'episode') : null)
        getUserStats()
        getUserAccess()
    }, []);

    function goToDetail() {
        navigate('/episodi/' + data.id)
    }


    if (data) {
        return (
            <Row className='align-items-stretch mb-4' style={{ border: '1px solid #ddd', borderRadius: '20px', overflow: 'hidden' }}>
                <Col xs={12} md={3} className='text-center py-3 d-flex align-items-center justify-content-center' style={blocked ? { backgroundColor: 'lightgray' } : { backgroundColor: 'var(--primary-color)' }}>
                    <h1 className='text-white'>{data.position || 0}</h1>
                </Col>
                <Col xs={12} md={9} className='mt-2 mb-2'>
                    <Row className='mt-4'>
                        <Col>
                            <p className='lead text-black'>{data.episodeDate ? moment(data.episodeDate).format("DD/MM/YYYY") : ''}</p>
                            <h4 className='text-black'>{data.name}</h4>
                        </Col>
                    </Row>
                    <Row className='align-items-center justify-content-between mb-4'>
                        <Col>
                            <p className='text-black m-0'>{data.estimatedMinutes} min</p>
                        </Col>
                        <Col>
                            {blocked === false && episodesStats && episodesStats.isCompleted ? (
                                <Badge bg='light' className='text-black'>Completato</Badge>
                            ) : null}
                        </Col>
                        {courseGranted ? (
                            <Col className='text-end me-4'>
                                {episodesStats ? <></> : <Button onClick={() => goToDetail()} style={blocked ? { borderRadius: '20px', display: 'none' } : { borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3'>Guarda<FontAwesomeIcon icon='circle-play' className='ms-2' /></Button>}
                                {episodesStats && episodesStats.isCompleted === 1 ? <Button onClick={() => goToDetail()} style={blocked ? { borderRadius: '20px', display: 'none' } : { borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3'>Rivedi<FontAwesomeIcon icon='circle-play' className='ms-2' /></Button> : <></>}
                                {episodesStats && episodesStats.isCompleted !== 1 ? <Button onClick={() => goToDetail()} style={blocked ? { borderRadius: '20px', display: 'none' } : { borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3'>Riprendi<FontAwesomeIcon icon='circle-play' className='ms-2' /></Button> : <></>}
                            </Col>
                        ) : null}
                    </Row>
                </Col>
            </Row>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};